import type { Output } from "./Kernel";

export const MAX_OUTPUT_BYTES = 256 * 1024;

const text = (t: string | string[] | undefined) => (Array.isArray(t) ? t.join("") : (t ?? ""));

/** Текст вывода для карточки Out: потоки, результат, трейсбек. */
export function outputText(outputs: Output[]): string {
  return outputs
    .map((o) => {
      switch (o.output_type) {
        case "stream":
          return text(o.text);
        case "execute_result":
          return text(o.data["text/plain"]);
        case "display_data":
          return o.data["image/png"] ? "" : text(o.data["text/plain"]);
        case "error":
          return text(o.traceback);
      }
    })
    .join("")
    .replace(/\n+$/, "");
}

export function firstError(outputs: Output[]) {
  const e = outputs.find((o) => o.output_type === "error");
  return e && e.output_type === "error" ? e : undefined;
}

/** Короткая подпись ошибки: «KeyError: '978-5-17-118366-0'». */
export function errorLabel(outputs: Output[]): string | undefined {
  const e = firstError(outputs);
  return e ? `${e.ename}: ${e.evalue}` : undefined;
}

/** Обрезка как на сервере: вывод ячейки > 256 КБ заменяется пометкой. */
export function trimOutputs(outputs: Output[], max = MAX_OUTPUT_BYTES): Output[] {
  const size = new TextEncoder().encode(JSON.stringify(outputs)).length;
  if (size <= max) return outputs;
  return [{ output_type: "stream", name: "stderr", text: [`вывод обрезан: больше ${Math.round(max / 1024)} КБ — уменьшите объём печати\n`] }];
}
